<adapt-two-column-layout [fullPage]="true"
                         leftColumnWidthClasses="col p-0"
                         rightColumnWidthClasses="col-auto"
                         class="activity-calendar">
    <div left-column
         class="h-100 d-flex flex-column p-3"
         #container>
        <bs-alert type="info"
                  [dismissible]="true"> This calendar shows activities inside {{ ProjectLabel }} only. It does not integrate with your
            personal or work calendar (e.g. Outlook / Google). </bs-alert>

        <ng-content></ng-content>

        <dx-load-panel [visible]="isFirstUpdate"
                       [container]="container"></dx-load-panel>

        <dx-scheduler #scheduler
                      [dataSource]="dataSource"
                      [remoteFiltering]="true"
                      [editing]="false"
                      [shadeUntilCurrentTime]="true"
                      [(currentDate)]="schedulerDate"
                      currentView="month"
                      startDateExpr="startDate"
                      endDateExpr="endDate"
                      allDayExpr="isAllDay"
                      textExpr="title"
                      class="flex-grow-1 h-100"
                      appointmentTemplate="appointmentTemplate"
                      appointmentTooltipTemplate="appointmentTooltip"
                      (onContentReady)="onCalendarLoad($event)"
                      (onAppointmentRendered)="onAppointmentRendered($event)"
                      (onCellClick)="onCalendarCellClick($event)"
                      (onAppointmentClick)="onAppointmentClick($event, scheduler.currentView)"
                      (onAppointmentFormOpening)="onAppointmentFormOpening($event)">
            <dxi-resource label="Type"
                          fieldExpr="type"
                          valueExpr="type"
                          displayExpr="shortTitle"
                          colorExpr="colourAccent"
                          [dataSource]="CulturalActivityTypeMetadata"
                          [useColorAsDefault]="true"></dxi-resource>
            <dxi-view type="workWeek"></dxi-view>
            <dxi-view type="month"></dxi-view>
            <dxi-view type="agenda"
                      [agendaDuration]="31"></dxi-view>
            <div *dxTemplate="let data of 'appointmentTemplate'"
                 (mouseenter)="onAppointmentHover($event, data)"
                 (mouseleave)="onAppointmentLeave()">
                @if (scheduler.currentView === "agenda") {
                    <div class="dx-scheduler-agenda-appointment-left-layout">
                        <div class="dx-scheduler-agenda-appointment-marker"></div>
                    </div>
                    <div class="dx-scheduler-agenda-appointment-right-layout">
                        <div class="dx-scheduler-appointment-title">
                            {{ data.appointmentData.title }}
                        </div>
                        <div class="dx-scheduler-appointment-content-details gap-2">
                            <div>
                                {{ data.appointmentData.metadata.shortTitle }}
                            </div>
                            @if (!data.appointmentData.isAllDay) {
                                <div class="dx-scheduler-appointment-content-date d-inline-flex align-items-center gap-1">
                                    <i class="fal fa-fw fa-clock"></i>
                                    {{ data.appointmentData.startDate | adaptTime }}
                                    @if (data.appointmentData.endDate) {
                                        -
                                        {{ data.appointmentData.endDate | adaptTime }}
                                    }
                                </div>
                            }
                        </div>
                    </div>
                } @else {
                    {{ data.appointmentData.title }}
                }
            </div>
            <div *dxTemplate="let data of 'appointmentTooltip'"
                 class="text-start">
                @if (calendarActivities.get(data.appointmentData.activityKey ?? ""); as activity) {
                    <ng-container *ngTemplateOutlet="activityTemplate; context: { $implicit: activity, actionable: false }"></ng-container>
                }
            </div>
        </dx-scheduler>
    </div>

    <ng-container right-column>
        @if (selectedCellData) {
            <adapt-universal-dashboard-element name="Due on {{ selectedCellData.date | adaptDate }}"
                                               class="flex-shrink-0">
                <span adapt-header-action-right
                      type="button"
                      (click)="selectedCellData = undefined; updateCalendarDimensions()"
                      class="btn-close"
                      data-bs-dismiss="alert"
                      aria-label="Close"></span>
                <div class="d-flex flex-column gap-1">
                    @if (selectedCellData.activities.length === 0) {
                        <p class="no-activity-placeholder">No activities fall on this date.</p>
                    }
                    @for (group of selectedCellData.activities; track groupTrackBy($index, group)) {
                        @if (CulturalActivityMetadataByType[group.key]; as typeMetadata) {
                            <adapt-universal-dashboard-element [name]="typeMetadata.title"
                                                               [background]="false"
                                                               [nested]="true"
                                                               [url]="routes[group.key]">
                                <div class="d-flex flex-row flex-wrap gap-3">
                                    @for (activity of group.items; track activityTrackBy($index, activity)) {
                                        <ng-container *ngTemplateOutlet="
                                                activityTemplate;
                                                context: {
                                                    $implicit: activity,
                                                    highlight: false,
                                                }
                                            "></ng-container>
                                    }
                                </div>
                            </adapt-universal-dashboard-element>
                        }
                    }
                </div>
            </adapt-universal-dashboard-element>
        }
    </ng-container>
</adapt-two-column-layout>
